import App from 'app/index'
import store from 'store'

const translateList = process.env.TRANSLATE_LIST?.split(',')
const defaultLanguage = 'en-EN'

function checkLocaleFile (language) {
  const languageIndex = translateList.indexOf(language)
  return languageIndex !== -1 ? translateList[languageIndex] : defaultLanguage
}

export function checkAvailableLocale (language) {
  if (checkLocaleFile(language) === defaultLanguage) {
    const langSubstr = language.substr(0, 2)
    language = checkLocaleFile(langSubstr + '-' + langSubstr.toUpperCase())
  }
  return language
}

function getI18nContext (App, context) {
  if (App.$i18n) {
    return App.$i18n
  } else if (context.$i18n) {
    return context.$i18n
  }

  return false
}

export function parseLocale (strLocale) {
  let [locale, suffix] = strLocale.toLowerCase().replace('_', '-').split('-')
  let parsedLocale = [locale]
  if (suffix) {
    parsedLocale.push('-', suffix.toUpperCase())
  }
  return parsedLocale.join('')
}

export function getDateLocale (locale) {
  const dateLocale = locale.substr(0, 2)
  return dateLocale === 'en' ? 'en-US' : dateLocale
}

// Some app locales (e.g. "ZH") do not map to a date-fns locale directory
// (date-fns ships zh-CN/zh-HK/zh-TW, not a bare "zh"). A failed dynamic import
// here was rejecting unhandled and crashing the whole app with a blank screen.
// Fall back to en-US so a missing/unsupported date-fns locale never breaks render.
export async function loadDateLocale (dateLocale) {
  try {
    return await import(/* webpackChunkName: "l10n/[request]" */ `date-fns/esm/locale/${dateLocale}/index.js`)
  } catch (error) {
    console.warn(`date-fns locale "${dateLocale}" not found, falling back to en-US.`, error)
    return import(/* webpackChunkName: "l10n/[request]" */ `date-fns/esm/locale/en-US/index.js`)
  }
}

export const TranslateApp = async context => {
  const i18nConstructor = getI18nContext(App, context)
  let i18nActive = null
  let i18nMessages = null

  const { user } = store.state.auth
  const locale = user && user.locale
  if (locale) {
    const parsedLocale = parseLocale(locale)
    await loadDateLocale(getDateLocale(parsedLocale))
    i18nActive = parsedLocale
  } else {
    i18nActive = parseLocale(window.navigator.language)
  }

  i18nActive = checkAvailableLocale(i18nActive)
  i18nMessages = await import(/* webpackChunkName: "i18n/[request]" */ `i18n/${i18nActive}.json`)

  i18nConstructor.setLocaleMessage(i18nActive, i18nMessages)
  i18nConstructor.locale = i18nActive
  document.documentElement.setAttribute('lang', i18nActive)
}
